import { render } from "./MessengerApi.vue?vue&type=template&id=7c7bdc77"
import script from "./MessengerApi.vue?vue&type=script&lang=js"
export * from "./MessengerApi.vue?vue&type=script&lang=js"

import "./MessengerApi.vue?vue&type=style&index=0&id=7c7bdc77&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__